import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef, ViewContainerRef, HostListener, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DQOIItem } from '@app/cp/shared/models/DQOIItem';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIMessage } from '@app/cp/shared/models/DQOIMessage';
import { Subscription } from 'rxjs';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import * as _ from 'lodash';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { Router } from '@angular/router';
import { ConstructionSearchComponent } from './search/construction-search.component';
import { CanComponentDeactivate } from '@app/cp/shared/guards/deactivate.guard';
import { CBOIComponent } from './cboi.component';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';

@Component({
    selector: 'construction-main',
    templateUrl: './construction-main.component.html',
    styleUrls: ['./construction-main.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConstructionMainComponent implements CanComponentDeactivate, AfterViewInit  {

    constructor(public globals: GlobalsService, svc_dqoi: DQOIService, private qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, private router: Router) {

        this.svc_dqoi = svc_dqoi;
        this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.url = this.router.url;
    }
    globalPropertiesActive: boolean = false;
    globalsOn() {
        this.globalPropertiesActive = true;
    }
    globalsOff() {
        this.globalPropertiesActive = false;
    }
    setContractFromRoute(url: string) {
        if (url.toLowerCase().indexOf("quickview") >= 0) {
            //this.searchComp.searchTargetChanged(SearchTarget.contract);
            alert('We on quickview');
        }
    }
    setSearchEventFromRoute(url: string) {
        if (url.toLowerCase().indexOf("contract") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.contract);
        }
        else if (url.toLowerCase().indexOf("job") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.job);
        }
        else if (url.toLowerCase().indexOf("invoice") >= 0) {
            this.searchComp.searchTargetChanged(SearchTarget.invoice);
        }
        else if ( url.toLowerCase().indexOf( "order" ) >= 0 ) {
            this.searchComp.searchTargetChanged( SearchTarget.order );
        } else if ( url.toLowerCase().indexOf( "quote" ) >= 0 ) {
            this.searchComp.searchTargetChanged( SearchTarget.quote );
        }
    }
    @ViewChild('searchComp') protected searchComp: ConstructionSearchComponent;
    @ViewChild("searchContainer", { read: ViewContainerRef }) public searchContainerRef: ViewContainerRef;
    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = false) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly);
        }
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            if (data.code === "REF_REFDATA") {
                this.refreshReferenceData();
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }

    }
    confirmCustom(data: ConfirmOutput) {

    }

    url: string;
    svc_dqoi: DQOIService;
    subs_dataSearchEvent: Subscription;
    dqoiItems: DQOIItem[] = [];

    trackByFunction(index: number, item: DQOIItem) {

        if (!item) return null;
        return item.index;
    }
    onDQOIMessage(e: DQOIMessage) {
        if (e.messageType === MessageType.close && CommonFunctions.hasValue(e.messageData)) {
            let index: number = e.messageData;
            let arr: DQOIItem[] = [];
            for (let i = 0; i < this.dqoiItems.length; i++) {
                if (index !== this.dqoiItems[i].index) {
                    arr.push(this.dqoiItems[i]);
                }
            }
            this.dqoiItems = arr;
            //_.remove(this.dqoiItems, function (n: DQOIItem) {
            //    return n.index === index;
            //});

            //            this.cd.detectChanges();
        }
        else if (e.messageType === MessageType.searchChanged) {
            this.searchComp.searchTargetChanged(e.messageData);
        }

    }
    addDQOIItem(data: DQOIItem) {
        let index: number = 1;
        if (CommonFunctions.hasArrayValue(this.dqoiItems)) {
            index = Math.max(...this.dqoiItems.map(x => x.index), 0) + 1;
        }
        data.index = index;
        data.isConstruction = true;

        this.svc_dqoi.setDQOIItem(data);
        this.dqoiItems = _.concat(data, this.dqoiItems);
    }
    ngAfterViewInit() {
        this.setSearchEventFromRoute(this.url);
        this.setContractFromRoute(this.url);
        this.svc_dqoi.dropQuickSearchAnchor(this.searchContainerRef);
    }
    ngOnDestroy() {
        this.svc_dqoi.dropQuickSearchAnchor(null);
    }
    test() {
        //let newItem: DQOIItem = { searchTarget: SearchTarget.dispatch,  target: 'D', id: 'DFF7B65B-F5D2-46CD-91F8-FD3862BB1FDA', index: 3, isSearchable: false, dispatchId: null, quoteId: null, orderId: null, invoiceId: null, number: null };
        //this.dqoiItems.push(newItem);
    }
    searchingActive: boolean = false;
    searchSel(data: DQOISearchEvent) {

        let se: DQOISearchEvent = new DQOISearchEvent(data);

        let item: DQOIItem = null;
        let idTarget = se.searchTarget + ":" + se.id;
        if (se.hasDispatchId) {
            this.svc_dqoi.getDQOITemConstFromDb(idTarget).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    item = new DQOIItem(info.primaryReturn);
                    console.log("cnst-main-srchsel-a: ", item, info);
                    //item.id = data.id;
                    //item.number = data.num
                    item.searchTarget = data.searchTarget;
                    if (item.isConstruction == true) {
                        if (CommonFunctions.hasGuidValue(item.masterJobId)) {
                            if (item.masterJobId !== item.dispatchId) {
                                //item.jobId = item.dispatchId;
                                //item.jobNumber = item.dispatchNumber;
                                item.dispatchId = item.masterJobId;
                                item.dispatchNumber = item.contractNumber;
                            }
                        }
                    }
                    switch (item.searchTarget) {
                        case SearchTarget.contract:
                            item.id = data.dispatchId;
                            item.dispatchId = item.id;
                            break;
                        case SearchTarget.job:
                            item.id = data.dispatchId;
                            //if (!item.hasDispatchId) {
                            //      item.dispatchId = item.id;
                            //}
                            break;
                        case SearchTarget.invoice:
                            item.number = data.invoiceNumber;
                            item.id = data.id;
                            break;
                        case SearchTarget.quote:
                            item.number = data.quoteNumber;
                            item.id = data.id;
                            break;
                        case SearchTarget.order:
                            item.number = data.orderNumber;
                            item.id = data.id;
                            break;
                    }

                    if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                        this.addDQOIItem(item);
                    }
                }
            });
        }
        else {
            item = new DQOIItem();
            item.searchTarget = data.searchTarget;
            if (item === null && data !== null) {
                switch (data.searchTarget) {
                    case SearchTarget.contract:
                        item.id = data.dispatchId;
                        item.dispatchId = item.id;
                        break;
                    case SearchTarget.job:
                        item.id = data.dispatchId;
                        item.dispatchId = item.id;
                        break;
                    case SearchTarget.invoice:
                        item.number = data.invoiceNumber;
                        break;
                    case SearchTarget.quote:
                        item.number = data.quoteNumber;
                        break;
                    case SearchTarget.order:
                        item.number = data.orderNumber;
                        break;
                }
            }
            if (CommonFunctions.hasValue(item.id) || CommonFunctions.hasValue(item.number)) {
                this.addDQOIItem(item);
            }
        }
    }
    @ViewChild('container', { read: ViewContainerRef }) public containerRef: ViewContainerRef;
    @ViewChildren('cboiInstance') cboiInstances: QueryList<CBOIComponent>;
    public newButtonData: Array<any> = [{
        text: 'New Contract',
        icon: 'briefcase',
        click: () => { this.newDQOI('C') }
    },
        {
            text: 'New Job',
            icon: 'hard-hat',
            click: () => { this.newDQOI('J') }
        },
        {
            text: 'New Bid',
            icon: 'quote',
            click: () => { this.newDQOI('Q') }
        },
        {
            text: 'New Order',
            icon: 'cart',
            click: () => { this.newDQOI('O') }
        }
    ];

    newDQOI(code: string) {
        let item: DQOIItem = new DQOIItem();
        item.isNew = true;
        switch (code) {
            case 'C':
                item.searchTarget = SearchTarget.contract;
                break;
            case 'J':
                item.searchTarget = SearchTarget.job;
                break;
            case 'Q':
                item.searchTarget = SearchTarget.quote;
                break;
            case 'O':
                item.searchTarget = SearchTarget.order;
                break;
            case 'I':
                item.searchTarget = SearchTarget.invoice;
                break;
        }
        this.addDQOIItem(item);
    }
    /* Prevent page reloading */
    @HostListener('window:beforeunload', ['$event'])
    canReload(e) {
        if (!this.canDeactivate()) e.returnValue = true;
    }

    canDeactivate = () => {
        var isClean = true;
        return isClean;
    };
    tryRefreshReferenceData() {
        let msg: string = "Are you sure you would like to Refresh this data?";
        let title: string = "Refresh Reference Data From the Server";
        this.cnfShow(msg, CRUDActions.None, null, title, "REF_REFDATA", false);
    }

    refreshReferenceData() {
        this.qry_rd.forceRefresh(this.globals.companyId);
    }

}
